/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
require('../vendor/magnific.js');

export function popup() {
  $('.popupLink').magnificPopup({
    type: 'inline',
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    gallery: {
      enabled: false
    },
    callbacks: {
      open: function () {
        // $(this).get(0).play();
        $(this.content).find('video')[0].play();
      },
      close: function () {
        $('video').each(function() {
          $(this).get(0).pause();
        });
      }
    }
  });
}
